import { useLocation } from 'react-router-dom';

/**
 * Hook to detect if the current route is in demo mode
 * Demo routes are prefixed with '/demo/'
 */
export const useDemoMode = (): boolean => {
  const location = useLocation();

  return location.pathname.startsWith('/demo/');
};

/**
 * Hook to get the appropriate route based on current demo mode
 * @param baseRoute - The base route (e.g., '/survey', '/generating-blueprint')
 * @returns The appropriate route (demo or production)
 */
export const useDemoAwareRoute = (baseRoute: string): string => {
  const isDemo = useDemoMode();

  return isDemo ? `/demo${baseRoute}` : baseRoute;
};

/**
 * Utility function to get demo-aware route without hook
 * @param baseRoute - The base route
 * @param isDemo - Whether we're in demo mode
 * @returns The appropriate route
 */
export const getDemoAwareRoute = (baseRoute: string, isDemo: boolean): string => {
  return isDemo ? `/demo${baseRoute}` : baseRoute;
};
